export default "__VITE_PUBLIC_ASSET__377c70e3__"